import { render } from "./Performance_S.vue?vue&type=template&id=c75d6064&scoped=true"
import script from "./Performance_S.vue?vue&type=script&lang=js"
export * from "./Performance_S.vue?vue&type=script&lang=js"

import "./Performance_S.vue?vue&type=style&index=0&id=c75d6064&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c75d6064"]])

export default __exports__